import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { UrlsUtils } from '../../utils/UrlsUtils';
import moment from 'moment';

export default function WidgetDataRow({ widget }) {

  const MAX_LENGTH = 25;
  const MAX_LENGTH_V = 38;

  return (() => {
    switch (widget.widget) {
      case 'Countdown':
        return <>
          <div className="col-2">
            {widget.data?.datetime ? moment(widget.data?.datetime).format("DD/MM/YYYY HH:mm:ss") :
              <FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} />
            }
          </div>
        
          <div className="col-5">
            <ul className="list-group list-group-flush" style={{ listStyleType: "none" }}>
                <>
                  <li className="list-group-item" style={{ padding: "0 0 0 10px" }}>
                    <div className="row" style={{ textAlign: "left" }}>
                      <div className="col-2" style={{ width: "68px", padding: "0px", color: "#808080" }}>
                        Bk_color:
                      </div>
                      <div className="col-10">
                      {widget.data?.bk_color ? widget.data?.bk_color :
                        <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>
                      }
                      </div>
                    </div>
                  </li>

                  <li className="list-group-item" style={{ padding: "0 0 0 10px" }}>
                    <div className="row" style={{ textAlign: "left" }}>
                      <div className="col-2" style={{ width: "68px", padding: "0px", color: "#808080" }}>
                        Image:
                      </div>
                      <div className="col-10">
                        {widget.data?.image_url ?
                          UrlsUtils.recognizingUrl(widget.data?.image_url) ?
                            <a type="button" href={widget.data?.image_url}
                              className="my-tooltip" title="Visualizza l'immagine" target="_blank" rel="noopener noreferrer">
                              {widget.data?.image_url?.length > MAX_LENGTH_V
                                ? widget.data?.image_url?.substring(0, MAX_LENGTH_V) + "..."
                                : widget.data?.image_url}
                            </a> :
                            <span style={{ color: "red" }}>
                              {widget.data?.image_url?.length > MAX_LENGTH
                                ? widget.data?.image_url?.substring(0, MAX_LENGTH) + "..."
                                : widget.data?.image_url}
                            </span>
                          : <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>}
                      </div>
                    </div>
                  </li>

                  <li className="list-group-item" style={{ padding: "0 0 0 10px" }}>
                    <div className="row" style={{ textAlign: "left" }}>
                      <div className="col-2" style={{ width: "68px", padding: "0px", color: "#808080" }}>
                        Text:
                      </div>
                      <div className="col-10">
                        {widget.data?.text ?
                          <span>
                            {widget.data?.text?.length > MAX_LENGTH_V
                              ? widget.data?.text?.substring(0, MAX_LENGTH_V) + "..."
                              : widget.data?.text}
                          </span>
                          : <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>}
                      </div>
                    </div>
                  </li>

                  <li className="list-group-item" style={{ padding: "0 0 0 10px" }}>
                    <div className="row" style={{ textAlign: "left" }}>
                      <div className="col-2" style={{ width: "68px", padding: "0px", color: "#808080" }}>
                        Txt_color:
                      </div>
                      <div className="col-10">
                        {widget.data?.text_color ?
                          <span>
                            {widget.data?.text?.length > MAX_LENGTH
                              ? widget.data?.text_color?.substring(0, MAX_LENGTH) + "..."
                              : widget.data?.text_color}
                          </span>
                          : <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>}
                      </div>
                    </div>
                  </li>
                </>
            </ul>
          </div>
        </>
      case 'MultipleLinkChips':
        return <>
          <div className="col-2">
            {widget.data?.chips?.length} Link Chips
          </div>
          <div className="col-5">
            <div className="row" style={{ textAlign: "left", padding: "0 0 0 10px" }}>
              <div className="col-2" style={{ width: "68px", padding: "0px", color: "#808080" }}>
                Title:
              </div>
              <div className="col-10">
                {widget.data?.title ?
                  <span>
                    {widget.data?.title?.length > MAX_LENGTH_V
                      ? widget.data?.title?.substring(0, MAX_LENGTH_V) + "..."
                      : widget.data?.title}
                  </span>
                  : <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>}
              </div>
            </div>
          </div>
        </>
      case 'CategoryHeader':
        return <>
          <div className="col-2">
            {widget.data?.text}
          </div>
          <div className="col-2">
            {widget.data?.color ? widget.data?.color :
              <FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} />
            }
          </div>
          <div className="col-3">
            {widget.data?.image_bk_url ?
              UrlsUtils.recognizingUrl(widget.data?.image_bk_url) ?
                <a type="button" href={widget.data?.image_bk_url}
                  className="my-tooltip" title="Visualizza l'immagine" target="_blank" rel="noopener noreferrer">
                  {widget.data?.image_bk_url?.length > MAX_LENGTH
                    ? widget.data?.image_bk_url?.substring(0, MAX_LENGTH) + "..."
                    : widget.data?.image_bk_url}
                </a> :
                <span style={{ color: "red" }}>
                  {widget.data?.image_bk_url?.length > MAX_LENGTH
                    ? widget.data?.image_bk_url?.substring(0, MAX_LENGTH) + "..."
                    : widget.data?.image_bk_url}
                </span>
              : <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>}
          </div>
        </>
      case 'VerticalHeader':
        return <>
          <div className="col-2">
            {widget.data?.bk_color}
          </div>
          <div className="col-5">
            <ul className="list-group list-group-flush" style={{ listStyleType: "none" }}>
              <li className="list-group-item" style={{ padding: "0 0 0 10px" }}>
                <div className="row" style={{ textAlign: "left" }}>
                  <div className="col-2" style={{ width: "68px", padding: "0px", color: "#808080" }}>
                    Backgr:
                  </div>
                  <div className="col-10">
                    {widget.data?.image_bk_url ?
                      UrlsUtils.recognizingUrl(widget.data?.image_bk_url) ?
                        <a type="button" href={widget.data?.image_bk_url}
                          className="my-tooltip" title="Visualizza l'immagine" target="_blank" rel="noopener noreferrer">
                          {widget.data?.image_bk_url?.length > MAX_LENGTH_V
                            ? widget.data?.image_bk_url?.substring(0, MAX_LENGTH_V) + "..."
                            : widget.data?.image_bk_url}
                        </a> :
                        <span style={{ color: "red" }}>
                          {widget.data?.image_bk_url?.length > MAX_LENGTH_V
                            ? widget.data?.image_bk_url?.substring(0, MAX_LENGTH_V) + "..."
                            : widget.data?.image_bk_url}
                        </span>
                      : <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>}
                  </div>
                </div>
              </li>
              <li className="list-group-item" style={{ padding: "0 0 0 10px" }}>
                <div className="row" style={{ textAlign: "left" }}>
                  <div className="col-2" style={{ width: "68px", padding: "0px", color: "#808080" }}>
                    Title:
                  </div>
                  <div className="col-10">
                    {widget.data?.image_title_url ?
                      UrlsUtils.recognizingUrl(widget.data?.image_title_url) ?
                        <a type="button" href={widget.data?.image_title_url}
                          className="my-tooltip" title="Visualizza l'immagine" target="_blank" rel="noopener noreferrer">
                          {widget.data?.image_title_url?.length > MAX_LENGTH_V
                            ? widget.data?.image_title_url?.substring(0, MAX_LENGTH_V) + "..."
                            : widget.data?.image_title_url}
                        </a> :
                        <span style={{ color: "red" }}>
                          {widget.data?.image_title_url?.length > MAX_LENGTH_V
                            ? widget.data?.image_title_url?.substring(0, MAX_LENGTH_V) + "..."
                            : widget.data?.image_title_url}
                        </span>
                      : <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>}
                  </div>
                </div>
              </li>
              <li className="list-group-item" style={{ padding: "0 0 0 10px" }}>
                <div className="row" style={{ textAlign: "left" }}>
                  <div className="col-2" style={{ width: "68px", padding: "0px", color: "#808080" }}>
                    Sponsor:
                  </div>
                  <div className="col-10">
                    {widget.data?.image_sponsor_url ?
                      UrlsUtils.recognizingUrl(widget.data?.image_sponsor_url) ?
                        <a type="button" href={widget.data?.image_sponsor_url}
                          className="my-tooltip" title="Visualizza l'immagine" target="_blank" rel="noopener noreferrer">
                          {widget.data?.image_sponsor_url?.length > MAX_LENGTH_V
                            ? widget.data?.image_sponsor_url?.substring(0, MAX_LENGTH_V) + "..."
                            : widget.data?.image_sponsor_url}
                        </a> :
                        <span style={{ color: "red" }}>
                          {widget.data?.image_sponsor_url?.length > MAX_LENGTH_V
                            ? widget.data?.image_sponsor_url?.substring(0, MAX_LENGTH_V) + "..."
                            : widget.data?.image_sponsor_url}
                        </span>
                      : <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </>
      case 'IndexHeader':
        return <>
          <div className="col-2">
            {widget.data?.text}
          </div>
          <div className="col-5">
            {widget.data?.image_bk_url ?
              UrlsUtils.recognizingUrl(widget.data?.image_bk_url) ?
                <a type="button" href={widget.data?.image_bk_url}
                  className="my-tooltip" title="Visualizza l'immagine" target="_blank" rel="noopener noreferrer">
                  {widget.data?.image_bk_url?.length > MAX_LENGTH_V
                    ? widget.data?.image_bk_url?.substring(0, MAX_LENGTH_V) + "..."
                    : widget.data?.image_bk_url}
                </a> :
                <span style={{ color: "red" }}>
                  {widget.data?.image_bk_url?.length > MAX_LENGTH
                    ? widget.data?.image_bk_url?.substring(0, MAX_LENGTH) + "..."
                    : widget.data?.image_bk_url}
                </span>
              : <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>}
          </div>
        </>
      case 'RubricHeader':
        return <>
          <div className="col-2">
            {widget.data?.text}
          </div>
          <div className="col-2">
            <div className="row">
              <div className="col-12">
                {widget.data?.text_color ? widget.data?.text_color :
                  <FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} />
                }
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {widget.data?.text_shadow ? widget.data?.text_shadow :
                  <FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} />
                }
              </div>
            </div>
          </div>
          <div className="col-3">
            <div className="row">
              <div className="col-12">
                {widget.data?.image_bk_url ?
                  UrlsUtils.recognizingUrl(widget.data?.image_bk_url) ?
                    <a type="button" href={widget.data?.image_bk_url}
                      className="my-tooltip" title="Visualizza l'immagine" target="_blank" rel="noopener noreferrer">
                      {widget.data?.image_bk_url?.length > MAX_LENGTH
                        ? widget.data?.image_bk_url?.substring(0, MAX_LENGTH) + "..."
                        : widget.data?.image_bk_url}
                    </a> :
                    <span style={{ color: "red" }}>
                      {widget.data?.image_bk_url?.length > MAX_LENGTH
                        ? widget.data?.image_bk_url?.substring(0, MAX_LENGTH) + "..."
                        : widget.data?.image_bk_url}
                    </span>
                  : <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {widget.data?.image_bk_url_4_3 ?
                  UrlsUtils.recognizingUrl(widget.data?.image_bk_url_4_3) ?
                    <a type="button" href={widget.data?.image_bk_url_4_3}
                      className="my-tooltip" title="Visualizza l'immagine" target="_blank" rel="noopener noreferrer">
                      {widget.data?.image_bk_url_4_3?.length > MAX_LENGTH
                        ? widget.data?.image_bk_url_4_3?.substring(0, MAX_LENGTH) + "..."
                        : widget.data?.image_bk_url_4_3}
                    </a> :
                    <span style={{ color: "red" }}>
                      {widget.data?.image_bk_url_4_3?.length > MAX_LENGTH
                        ? widget.data?.image_bk_url_4_3?.substring(0, MAX_LENGTH) + "..."
                        : widget.data?.image_bk_url_4_3}
                    </span>
                  : <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>}
              </div>
            </div>
          </div>
        </>
      case 'SingleLive':
        return <>
          <div className="col-2">
            Live ID Number
          </div>
          <div className="col-5">
            {widget.data?.id}
          </div>
        </>
      case 'SingleHugeArticle':
      case 'SingleBigArticle':
      case 'SingleMediumArticle':
        return <>
          <div className="col-2">
            {widget.data?.reversed ?
              <ul className="list-group list-group-flush">
                <li className="list-group-item" style={{ padding: "0" }}>
                  {widget.data?.origin_domain}
                </li>
                <li className="list-group-item" style={{ padding: "0" }}>
                  {widget.data?.reversed && 'Reversed'}
                </li>
              </ul>
              : widget.data?.origin_domain}
          </div>
          <div className="col-5">
            {widget.data?.title}
          </div>
        </>
      case 'MultipleSelectedArticles':
        return <>
          <div className="col-7">
            {widget.data?.length} Post
          </div>
        </>
      case 'MultipleSelectedArticlesSlider':
        return <>
          <div className="col-2">
            {widget.data?.length} Post
          </div>
          <div className="col-5">
            Slider
          </div>
        </>
      case 'MultipleArticles':
      case 'TrendingTopics':
      case 'TrendingTopicsMultipleSelectedArticles':
        return <>
          <div className="col-2">
          {(widget.widget === 'TrendingTopics' || widget.widget === 'TrendingTopicsMultipleSelectedArticles') ?
            widget.data?.show_article_images ?
              <ul className="list-group list-group-flush">
                <li className="list-group-item" style={{ padding: "0" }}>
                  {widget.widget === 'TrendingTopicsMultipleSelectedArticles' ? 
                    widget.data?.posts?.length + ' Post' : 
                  widget.data?.number + ' Post'}
                </li>
                <li className="list-group-item" style={{ padding: "0" }}>
                  {widget.data?.show_article_images && 'Show Article Images'}
                </li>
              </ul>
              : widget.data?.posts?.length + ' Post'
          : widget.data?.number + ' Post'}
          </div>
          <div className="col-5">
            <ul className="list-group list-group-flush" style={{ listStyleType: "none" }}>
              {(widget.widget === 'TrendingTopics' || widget.widget === 'TrendingTopicsMultipleSelectedArticles') &&
                <>
                  <li className="list-group-item" style={{ padding: "0 0 0 10px" }}>
                    <div className="row" style={{ textAlign: "left" }}>
                      <div className="col-2" style={{ width: "68px", padding: "0px", color: "#808080" }}>
                        Title:
                      </div>
                      <div className="col-10">
                        {widget.data?.title ?
                          <span>
                            {widget.data?.title?.length > MAX_LENGTH_V
                              ? widget.data?.title?.substring(0, MAX_LENGTH_V) + "..."
                              : widget.data?.title}
                          </span>
                          : <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>}
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item" style={{ padding: "0 0 0 10px" }}>
                    <div className="row" style={{ textAlign: "left" }}>
                      <div className="col-2" style={{ width: "68px", padding: "0px", color: "#808080" }}>
                        Text:
                      </div>
                      <div className="col-10">
                        {widget.data?.text ?
                          <span>
                            {widget.data?.text?.length > MAX_LENGTH_V
                              ? widget.data?.text?.substring(0, MAX_LENGTH_V) + "..."
                              : widget.data?.text}
                          </span>
                          : <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>}
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item" style={{ padding: "0 0 0 10px" }}>
                    <div className="row" style={{ textAlign: "left" }}>
                      <div className="col-2" style={{ width: "68px", padding: "0px", color: "#808080" }}>
                        URL:
                      </div>
                      <div className="col-10">
                        {widget.data?.url ?
                          UrlsUtils.recognizingUrl(widget.data?.url) ?
                            <a type="button" href={widget.data?.url}
                              className="my-tooltip" title="Visualizza l'immagine" target="_blank" rel="noopener noreferrer">
                              {widget.data?.url?.length > MAX_LENGTH_V
                                ? widget.data?.url?.substring(0, MAX_LENGTH_V) + "..."
                                : widget.data?.url}
                            </a> :
                            <span style={{ color: "red" }}>
                              {widget.data?.url?.length > MAX_LENGTH_V
                                ? widget.data?.url?.substring(0, MAX_LENGTH_V) + "..."
                                : widget.data?.url}
                            </span>
                          : <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>}
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item" style={{ padding: "0 0 0 10px" }}>
                    <div className="row" style={{ textAlign: "left" }}>
                      <div className="col-2" style={{ width: "68px", padding: "0px", color: "#808080" }}>
                        Backgr:
                      </div>
                      <div className="col-10">
                        {widget.data?.image_bk_url ?
                          UrlsUtils.recognizingUrl(widget.data?.image_bk_url) ?
                            <a type="button" href={widget.data?.image_bk_url}
                              className="my-tooltip" title="Visualizza l'immagine" target="_blank" rel="noopener noreferrer">
                              {widget.data?.image_bk_url?.length > MAX_LENGTH_V
                                ? widget.data?.image_bk_url?.substring(0, MAX_LENGTH_V) + "..."
                                : widget.data?.image_bk_url}
                            </a> :
                            <span style={{ color: "red" }}>
                              {widget.data?.image_bk_url?.length > MAX_LENGTH_V
                                ? widget.data?.image_bk_url?.substring(0, MAX_LENGTH_V) + "..."
                                : widget.data?.image_bk_url}
                            </span>
                          : <div style={{ textAlign: "center" }}><FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} /></div>}
                      </div>
                    </div>
                  </li>
                </>
              }
              {widget.widget !== 'TrendingTopicsMultipleSelectedArticles' &&
                widget.data?.filters?.map((filter, index) => {
                  return <li key={index} className="list-group-item" style={{ padding: "0 0 0 10px" }}>
                    <div className="row" style={{ textAlign: "left" }}>
                      <div className="col-2" style={{ width: "68px", padding: "0px", color: "#808080" }}>
                        {filter.field === 'origin_domain' && 'Domain: '}
                        {filter.field === 'category_parent_slug' && 'Category: '}
                        {filter.field === 'tags_slug__in' && 'Hashtag: '}
                      </div>
                      <div className="col-10">
                        <span>{filter.value}</span>
                      </div>
                    </div>
                  </li>
                })
              }
            </ul>
          </div>
        </>
      case 'SocialMediaButtons':
      case 'EventSlider':
      case 'AnnouncementSlider':
      case 'Banners':
      case 'SearchLiveBar':
        return <div className="col-7 p-0"></div>
      case 'CustomPagination':
        return <>
          <div className="col-2">
            <div className="row">
              <div className="col-12">
                {widget.data?.text_left ?
                  widget.data?.text_left
                  : <div style={{ textAlign: "center" }}>
                    <FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} />
                  </div>}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {widget.data?.text_right ?
                  widget.data?.text_right
                  : <div style={{ textAlign: "center" }}>
                    <FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} />
                  </div>}
              </div>
            </div>
          </div>
          <div className="col-5">
            <div className="row">
              <div className="col-12">
                {widget.data?.url_left ?
                  UrlsUtils.recognizingUrl(widget.data?.url_left) ?
                    <a type="button" href={widget.data?.url_left}
                      className="my-tooltip" title="Visualizza pagina" target="_blank" rel="noopener noreferrer">
                      {widget.data?.url_left?.length > MAX_LENGTH
                        ? widget.data?.url_left?.substring(0, MAX_LENGTH) + "..."
                        : widget.data?.url_left}
                    </a> :
                    <span style={{ color: "red" }}>
                      {widget.data?.url_left?.length > MAX_LENGTH
                        ? widget.data?.url_left?.substring(0, MAX_LENGTH) + "..."
                        : widget.data?.url_left}
                    </span>
                  : <div style={{ textAlign: "center" }}>
                    <FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} />
                  </div>}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {widget.data?.url_right ?
                  UrlsUtils.recognizingUrl(widget.data?.url_right) ?
                    <a type="button" href={widget.data?.url_right}
                      className="my-tooltip" title="Visualizza pagina" target="_blank" rel="noopener noreferrer">
                      {widget.data?.url_right?.length > MAX_LENGTH
                        ? widget.data?.url_right?.substring(0, MAX_LENGTH) + "..."
                        : widget.data?.url_right}
                    </a> :
                    <span style={{ color: "red" }}>
                      {widget.data?.url_right?.length > MAX_LENGTH
                        ? widget.data?.url_right?.substring(0, MAX_LENGTH) + "..."
                        : widget.data?.url_right}
                    </span>
                  : <div style={{ textAlign: "center" }}>
                    <FontAwesomeIcon icon={['fas', 'ban']} size={'1x'} color={'#ED6C02'} />
                  </div>
                }
              </div>
            </div>
          </div>
        </>
      case 'CustomEditor':
        return <>
          <div className="col-2">
            <span>{widget.data?.typeOf}</span>
            {
              widget.data?.hide === true &&
              <span style={{ color: "#ED6C02" }}>
                &nbsp;(Hidden)
              </span>
            }
          </div>
          <div className="col-5">
            {widget.data?.name}
          </div>
        </>
      default:
        return <div className='d-none'>
          Not managed widget {widget?.widget}
        </div>
    }
  }
  )()
}
